import React from "react";
import { InputTypeAhead, PrimaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";
import styled from "styled-components";

import { WIDTH } from "../lenderReportingSettings";

import { UsersTable } from "./";

const PADDING = "2em";

const SettingsModuleContainer = styled.div`
    width: calc(${WIDTH} - ${PADDING});
    box-shadow: 0px 10px 20px 0px #ADAEAE40;
    transform: translateY(-7em);
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 8px;
    font-family: Work Sans;
`;

const TitleSubtitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: ${PADDING};
`;

const Title = styled.div`
    font-weight: 500;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
`;

const Subtitle = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
`;

const AddUserWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 2em;
    align-items: flex-end;
    padding: ${PADDING};
`;

const StyledInputTypeAhead = styled(InputTypeAhead)`&&& {
    width: 238px;
    height: 56px;
}`;

const StyledPrimaryButton = styled(PrimaryButton)`&&& {
    font-family: Work Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    width: 136px;
    height: 36px;
}`;

const SettingsModule = ({
  allUsers,
  permissionedUsersState,
  setPermissionedUsersState,
  handleRoleSelection,
  handleCheck,
  handleDeleteRow,
  handleAddRow,
  selectedUser,
  setSelectedUser
}) => (
  <SettingsModuleContainer>
    <TitleSubtitleWrapper>
      <Title>User Permissions</Title>
      <Subtitle>Add or remove users from your organization who can use the Lender Compliance Reporting Dashboard.</Subtitle>
    </TitleSubtitleWrapper>
    <AddUserWrapper>
      <StyledInputTypeAhead
        className="input"
        label="Select a user"
        variant="filled"
        displayWith={option => option?.name}
        setValueWith={option => ({ id: option?.id, name: option?.name })}
        onChange={user => setSelectedUser({ id: user?.id, name: user?.name })}
        options={allUsers}
      />
      <StyledPrimaryButton
        disabled={!selectedUser?.id || !selectedUser?.name}
        label="Add User"
        size={ButtonSizeOptions.smFluid}
        onClick={() => {
          handleAddRow(selectedUser?.id);
          setSelectedUser({ id: "", name: "" });
        }}
      />
    </AddUserWrapper>
    <UsersTable
      handleCheck={handleCheck}
      handleDeleteRow={handleDeleteRow}
      handleRoleSelection={handleRoleSelection}
      permissionedUsersState={permissionedUsersState}
      setPermissionedUsersState={setPermissionedUsersState}
    />
  </SettingsModuleContainer>
);

export default SettingsModule;
